/**
 * LoginHeader Component
 * Simple header with logo and title for modern design
 * Follows composition pattern and React conventions
 */

import React from 'react';
import { Typography } from 'antd';
import { LoginHeaderProps } from '../../types/auth.types';
import { useResponsiveDesign } from '../../hooks/useResponsiveDesign';
import styles from './LoginHeader.module.scss';

const { Title } = Typography;

const LoginHeader: React.FC<LoginHeaderProps> = ({
  title = "NAVI PORTAL",
  logoSrc = "/images/logo-fpt.png", 
  logoAlt = "FPT Logo",
  className = "",
}) => {
  const { isMobile } = useResponsiveDesign();

  return (
    <div className={`${styles.headerContainer} ${className}`}>
      {/* Logo and Title Section */}
      <div className={styles.logoSection}>
        <div className={styles.logoContainer}>
          <img 
            src={logoSrc}
            alt={logoAlt}
            className={styles.logo}
          />
        </div>
        <Title 
          level={2} 
          className={styles.title}
        >
          {title}
        </Title>
      </div>
    </div>
  );
};

LoginHeader.displayName = 'LoginHeader';

export default LoginHeader;